/* eslint-disable react/prop-types */
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  Button,
  makeStyles,
  DialogActions,
  DialogContent,
  CircularProgress,
  Snackbar
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { deleteUser } from "lib/services/users";

const useStyles = makeStyles(theme => ({
  addUserButton: {
    backgroundColor: "#90cb7c"
  },
  button: {
    margin: theme.spacing(1)
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative"
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
}));

function Alert(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function DeleteUserComponent({
  user,
  open,
  onSuccess,
  onDismiss
}) {
  const classes = useStyles(() => ({
    dialogContent: {
      padding: "20px"
    }
  }));
  const [loading, setLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "",
    message: ""
  });

  const handleDeleteConfirm = async e => {
    e.preventDefault();
    setLoading(true);
    const newSnackbarState = {
      open: true,
      severity: "success",
      message: `${user.email} deleted successfully!`
    };

    try {
      await deleteUser(user.id);
      onSuccess();
    } catch (error) {
      newSnackbarState.severity = "error";
      newSnackbarState.message = "An error occurred. Please try again shortly";
    } finally {
      setLoading(false);
      setSnackbarState(newSnackbarState);
    }
  };

  const handleSnackbarClose = (_event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarState(prevState => {
      return {
        ...prevState,
        open: false
      };
    });
  };

  return (
    <>
      <Dialog
        onClose={onDismiss}
        className={classes.dialogContent}
        open={open}
        aria-labelledby="add-user-form-dialog-title"
      >
        <DialogTitle id="add-user-form-dialog-title">
          Permanently delete user 
          {' '}
          <b>{user?.email}</b>
          ?
        </DialogTitle>
        <DialogContent>
          This action is not reversible. However, creating a new user with the
          same email will have the same effect as updating the user data, but
          the password will be reset
        </DialogContent>
        <DialogActions>
          <Button onClick={onDismiss}>Cancel</Button>
          <div className={classes.wrapper}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDeleteConfirm}
              disabled={loading}
            >
              Delete user
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarState.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarState.severity}>
          {snackbarState.message}
        </Alert>
      </Snackbar>
    </>
  );
}
